import AccountActions from 'components/AccountActions';
import React from 'react';

import OPCImg from 'assets/img/opc_solo.png';
import styles from './styles.module.scss';

const HeaderOPC: React.FC = () => (
  <header className={styles.wrapper}>
    <div className="container d-flex justify-content-between p-2 align-items-center">
      <div className={styles.logo}>
        <img src={OPCImg} alt="OPC" />
        <h1>Open Platform Comunication</h1>
      </div>

      <AccountActions />
    </div>
  </header>
);

export default HeaderOPC;
